import R, {LOADER} from "../lib/requests";
import {millisecondsToHours, setFocusTo, YMD_HMS} from "../lib/lib";
import {writable} from 'svelte/store';


const createClockingTask = (task) => {
    const onSuccess = result => {
        clocking.setTask(result);
    }

    const onFailure = err => {
    };

    R.handle(R.clockingTask.create, task, onSuccess, onFailure).then(r => {
    });
}

const emptyTask = () => {
    return {
        id: 0,
        name: '',
        duration: 0,
        is_billable: 1,
        date: null,
        start_at: null,
        end_at: null,
        tags: [],
    }
}

let clockingObject = {
    task: {
        id: 0,
        duration: 0,
        is_billable: 1,
        date: null,
    },

    showTaskModal: false,
};

const {get, set, update, subscribe} = writable(clockingObject);

const clocking = {
    set,
    update,
    subscribe,

    start: (data = null) => {
        if (!data) {
            data = {};
        }
        clocking.update(obj => {
            obj.task = emptyTask();
            obj.task.name = data.name || '';
            obj.task.start_at = YMD_HMS(new Date());
            obj.task.project_id = data.project_id || null;
            obj.task.project = data.project || null;
            obj.task.tags = data.tags || [];

            createClockingTask(obj.task);

            return obj;
        });
    },

    setTask: data => {
        clocking.update(obj => {
            obj.task = data;
            obj.task.date = new Date(obj.task.start_at);

            return obj;
        });
    },

    clear: () => {
        clocking.update(obj => {
            obj.task = emptyTask();
            return obj;
        });
    },

    setDuration: () => {
        if (clockingObject.task.id > 0) {
            clocking.update(obj => {
                obj.task.duration = new Date() - obj.task.date;

                return obj;
            });
        }
    },

    getDurationString: () => {
        if (!clockingObject.task.duration) {
            return '';
        }
        return millisecondsToHours(clockingObject.task.duration);
    },

    onProgress: () => {
        return clockingObject.task && clockingObject.task.id > 0;
    }
}

export default clocking;